import React,{useEffect} from 'react'
import Header from '../Header/Main'
import Footer from '../Footer/Main'
import GalleryBred from '../BredCrumb/GalleryBred'
import Gallery from '../MenGallery/Gallery'
import Aos from 'aos'

function Main() {
    
    useEffect(() => {
         window.scrollTo(0,0);
      }, []);

    return (
        <div>
            <Header />
            <GalleryBred />
            <Gallery/>
            <Footer />
        </div>
    )
}

export default Main